<template>
  <button
    type="button"
    class="button"
    v-text="text"
    :class="{
      'button--active': active,
      'button--dark': type === 'dark',
      'button--tab': type === 'tab',
    }"
    @click="handleClick"
  />
</template>
<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
$btn: '.button';
#{$btn} {
  height: 58px;
  line-height: 57px;
  border: solid 1px #121212;
  background-color: #fff;
  padding: 0 30px;
  border-radius: 28px;
  font-size: 22px;
  font-weight: 400;
  color: #121212;
  &--active {
    background-color: #fd312e;
    color: #fff;
    border-color: #fd312e;
  }
  &--dark {
    height: 63px;
    line-height: 62px;
    border-radius: 20px;
    &#{$btn}--active {
      background-color: #1a1a1a;
      border-color: #1a1a1a;
    }
  }
  &--tab {
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    border: 0;
    border-radius: 0;
    padding: 0 7px 10px;
    background-color: transparent;
    &.button--active {
      color: #000;
      border-bottom: solid 1px #000;
    }
  }
  @media screen and (max-width: 1080px) {
    font-size: calcQuarter(44);
    height: calcQuarter(114);
    line-height: calcQuarter(110);
    padding: 0 calcQuarter(68);
    &--dark {
      font-size: calcQuarter(48);
      height: calcQuarter(124);
      line-height: calcQuarter(120);
      padding: 0 calcQuarter(50);
      border-radius: calcQuarter(30);
    }
    &--tab {
      font-size: calcQuarter(56);
      font-weight: 600;
      padding: 0 calcQuarter(18) 10px;
    }
  }
}
</style>
